<template>
  <div>
    <h6 class="font-semibold my-20">
      {{
        $route.params.id ? "Cập nhật tin tuyển dụng" : "Thêm mới tin tuyển dụng"
      }}
    </h6>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Mô tả" prop="description">
          <a-input v-model="form.description" placeholder="Mô tả" />
        </a-form-model-item>
        <a-form-model-item
          class="mb-5"
          label="Nội dung công việc"
          prop="content"
        >
          <mavon-editor
            v-model="form.content"
            language="en"
            placeholder="Nhập nội dung"
          />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Công ty" prop="company_name">
          <a-input v-model="form.company_name" placeholder="Nhập tên công ty" />
        </a-form-model-item>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Ngành nghề"
              prop="career_category_id"
            >
              <a-select
                v-model="form.career_category_id"
                class="w-full"
                placeholder="Chọn"
                show-search
                allowClear
                option-filter-prop="children"
              >
                <a-select-option
                  v-for="item in listCategory"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item class="mb-5" label="Mức lương" prop="salary">
              <a-input v-model="form.salary" class="w-full" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Địa chỉ làm việc"
              prop="address"
            >
              <a-input v-model="form.address" placeholder="Địa chỉ làm việc" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Tỉnh / Thành phố"
              prop="place"
            >
              <a-select
                v-model="form.place"
                class="w-full"
                allowClear
                placeholder="Chọn địa điểm"
              >
                <a-select-option value="HN">Hà Nội</a-select-option>
                <a-select-option value="HCM">Hồ Chí Minh</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Thời gian bắt đầu nhận hồ sơ"
              prop="start_receive"
            >
              <a-date-picker v-model="form.start_receive" class="w-full" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Thời gian kết thúc nhận hồ sơ"
              prop="expiration_date"
            >
              <a-date-picker v-model="form.expiration_date" class="w-full" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Số lượng tuyển"
              prop="recruitment_number"
            >
              <a-input-number
                :min="1"
                :max="100000"
                class="w-full"
                v-model="form.recruitment_number"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              class="mb-5"
              label="Hình thức làm việc"
              prop="work_time"
            >
              <a-radio-group
                name="work_time"
                v-model="form.work_time"
                :default-value="1"
              >
                <a-radio :value="1"> Full time </a-radio>
                <a-radio :value="2"> Part time </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row type="flex" justify="end" class="mt-20">
          <a-button type="primary" :loading="callingAPI" @click="handleSubmit">
            {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
          </a-button>
        </a-row>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { fetchCategory } from "@/services/landing-page/career/career-category";
import {
  fetchRecruimentById,
  createRecruiment,
  updateRecruiment,
} from "@/services/landing-page/career/career";
import dayjs from "dayjs";
export default {
  name: "ControllerRecruiment",
  data() {
    return {
      callingAPI: false,

      form: {
        title: "",
        description: "",
        content: "",
        company_name: "",
        address: "",
        place: "",
        salary: "",
        work_time: 1,
        start_receive: null,
        expiration_date: null,
        recruitment_number: 1,
        career_category_id: "",
        status: 1,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        company_name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        place: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        salary: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        compawork_timeny_name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        start_receive: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        expiration_date: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        recruitment_number: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        career_category_id: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },
      listCategory: [],
    };
  },
  async created() {
    await this.loadCategory();
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    dayjs,

    async loadCategory() {
      try {
        const response = await fetchCategory();
        this.listCategory = response.data.data;
      } catch (error) {}
    },
    async loadData() {
      try {
        const response = await fetchRecruimentById(this.$route.params.id);

        for (var key in this.form) {
          if (response.data.hasOwnProperty(key)) {
            this.form[key] = response.data[key];
          }
        }
      } catch (error) {}
    },
    async handleSubmit() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.callingAPI = true;
            const data = {
              ...this.form,
              start_receive: dayjs(this.form.start_receive).format(
                "DD/MM/YYYY"
              ),
              expiration_date: dayjs(this.form.expiration_date).format(
                "DD/MM/YYYY"
              ),
            };
            let message;
            if (this.$route.params.id) {
              data._method = "PUT";
              await updateRecruiment(this.$route.params.id, data);
            } else {
              await createRecruiment(data);
            }
            this.callingAPI = false;
            message = this.$route.params.id
              ? "Cập nhật thành công"
              : "Thêm mới thành công";
            this.$notification.success({
              message: "Thành công",
              description: message,
            });
            this.$router.push({ name: "ManageRecruitment" });
          }
        });
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
</style>